import React, { useState } from 'react';
import { auth, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut } from './auth';
import { sendPasswordResetEmail, sendEmailVerification } from 'firebase/auth';

import { useNavigate } from 'react-router-dom';

export function AuthPage({ onAuth }) {
  const [isRegister, setIsRegister] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [resetSent, setResetSent] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    try {
      if (isRegister) {
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        await sendEmailVerification(userCredential.user);
        await signOut(auth); // Sign out immediately
        alert(`Registration successful! A verification email has been sent to ${email}. Please check your email and verify before logging in.`);
        setIsRegister(false); // Switch to login mode
      } else {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        if (!userCredential.user.emailVerified) {
            await signOut(auth);
            throw new Error("Please verify your email address before logging in. Check your inbox.");
        }
        // If verified, App.js will detect the state change and setAuthed(true)
      }
    } catch (err) {
      setError(err.message);
    }
  }

  async function handleForgotPassword(e) {
    e.preventDefault();
    setError('');
    setResetSent(false);
    if (!email) {
      setError('Please enter your email to reset password.');
      return;
    }
    try {
      const actionCodeSettings = {
        // Redirect to the login page (root) after password reset on Firebase handler
        url: window.location.origin, 
        handleCodeInApp: false, // Use the standard Firebase password reset page
      };
      await sendPasswordResetEmail(auth, email, actionCodeSettings);
      setResetSent(true);
    } catch (err) {
      setError(err.message);
    }
  }

  return (
    <div className="auth-container">
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <h1 style={{ color: '#1976d2' }}>Reflections OC Portal</h1>
        <p style={{ color: '#666' }}>Authorized Personnel Only</p>
      </div>
      <form className="auth-form" onSubmit={handleSubmit}>
        <h2>{isRegister ? 'Register' : 'Sign In'}</h2>
        <label>Email</label>
        <input type="email" value={email} onChange={e => setEmail(e.target.value)} required />
        <label>Password</label>
        <input type="password" value={password} onChange={e => setPassword(e.target.value)} required />
        {error && <div className="auth-error">{error}</div>}
        {resetSent && <div style={{ color: '#1976d2', marginBottom: 8 }}>Password reset email sent!</div>}
        {!isRegister && (
          <div style={{ marginBottom: 12 }}>
            <button type="button" style={{ background: 'none', color: '#1976d2', border: 'none', textDecoration: 'underline', cursor: 'pointer', fontSize: '1em', padding: 0 }} onClick={handleForgotPassword}>
              Forgot Password?
            </button>
          </div>
        )}
        <button type="submit">{isRegister ? 'Register' : 'Sign In'}</button>
        <div className="auth-toggle">
          {isRegister ? (
            <span>Already have an account? <button type="button" onClick={() => setIsRegister(false)}>Sign In</button></span>
          ) : (
            <span>Don't have an account? <button type="button" onClick={() => setIsRegister(true)}>Register</button></span>
          )}
        </div>
      </form>
    </div>
  );
}
